import React from "react"
import {Container} from "./component"

export type MiniShoppingBagCheckoutDefaultProps = {
    children: React.ReactNode
}

export const MiniShoppingBagCheckout = (props: MiniShoppingBagCheckoutDefaultProps) => {
    const {children} = props
    return (
        <Container data-testid="minibag-adaptive-checkout" className="header-adaptive-checkout">
            {children}
        </Container>
    )
}

export default MiniShoppingBagCheckout
